<template>
  <Dialog
    ref="productVolumePricingRef"
    dialog-mode="small"
    content-class="dialog-content !pt-3"
    header-class="gap-2 flex !justify-start align-center"
    footer-class="border-t border-solid border-[--color-neutral-a4] !justify-center"
    class="dialog-x-small"
  >
    <template #title>
      <span class="text-lg font-bold">{{ volumePricingProduct?.code }}</span>
    </template>
    <template v-if="hasTierPrices(volumePricingProduct as Product)" #content>
      <VolumePricing :product="volumePricingProduct as Product" :hide-ladder-discount="hideLadderDiscount" />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { ref, onUnmounted } from "vue";
import { useCurrency } from "@/core/composables";
import { eventBus } from "@/shared/thorlabs/shared";
import type { Product, VariationTypeExtension } from "@/core/api/graphql/types";
import VolumePricing from "@/shared/thorlabs/product-family/components/dialog/volume-pricing-dialog.vue";
import Dialog from "@/shared/thorlabs/shared/components/dialog-modal.vue";

const { currentCurrency } = useCurrency();
const volumePricingProduct = ref<Product | VariationTypeExtension | null>(null);
const productVolumePricingRef = ref<typeof Dialog | null>(null);
const hideLadderDiscount = ref<boolean | undefined>(undefined);

eventBus.on("showVolumePricingDialog", (payload) => {
  volumePricingProduct.value = { ...payload.product };
  hideLadderDiscount.value = payload.hideLadderDiscount;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  productVolumePricingRef.value?.openDialog();
});

function hasTierPrices(product: Product) {
  const currentCurrencyPriceTier = product?.price?.tierPrices?.filter(
    (p) => p.price.currency.code === currentCurrency.value.code,
  );

  return !!(currentCurrencyPriceTier && currentCurrencyPriceTier.length > 1);
}

onUnmounted(() => {
  eventBus.off("showVolumePricingDialog");
});
</script>
